import { BRAND } from "@/lib/data";

export default function WhatsAppButton() {
  const href = `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(
    "Hi ZEBO! I'd like to know more about your interior design services."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow noopener noreferrer external"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with ZEBO on WhatsApp"
      title="Chat with ZEBO on WhatsApp (+91 90512 93651)"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg rounded-full hover:scale-105 hover:shadow-xl transition-transform duration-300 group"
    >
      <svg viewBox="0 0 32 32" width="24" height="24" fill="currentColor" aria-hidden="true">
        <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.74 6.4L3.2 28.8l6.6-1.72a12.72 12.72 0 0 0 6.2 1.58h.01c7.06 0 12.8-5.74 12.8-12.8s-5.75-12.86-12.81-12.86zm0 23.3h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.92 1.02 1.05-3.82-.25-.4a10.55 10.55 0 0 1-1.62-5.62c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.11 7.52 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.87-4.77 10.62-10.63 10.62zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55l-.61-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63s1.13 3.05 1.28 3.26c.16.21 2.22 3.39 5.38 4.75.75.32 1.34.52 1.8.66.76.24 1.44.21 1.98.13.6-.09 1.89-.77 2.16-1.52.27-.75.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37z" />
      </svg>
      <span className="text-sm font-bold hidden sm:inline">Chat with us</span>
    </a>
  );
}
